function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgSedan = function SvgSedan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6 2.885a2.277 2.277 0 00-.133.191L5.865 5.663l1.735.034V2.885zm1.2-.804v3.64l6.64.13V2H9.4c-.205 0-.407.028-.6.08zM9.4.8c-1.202 0-2.32.622-2.953 1.644L4.466 5.642h-1.65a1.4 1.4 0 00-1.398 1.4v.966l-.586 1.72A.6.6 0 00.8 9.92v2.097A1.4 1.4 0 001.974 13.4l2.543.333A3.397 3.397 0 007.869 16.6a3.397 3.397 0 003.342-2.8h11.197a3.397 3.397 0 003.341 2.8 3.397 3.397 0 003.342-2.8h1.96c.484 0 .948-.195 1.287-.541a3.017 3.017 0 00.293-3.875l-.91-1.264a2.197 2.197 0 00-1.247-.847l-.01-.002-4.342-1.012-3.478-3.912A4.608 4.608 0 0019.2.8H9.4zM16.64 2v3.875l7.67.151-2.563-2.882A3.408 3.408 0 0019.2 2h-2.56zm-.61 5.063h-.003L8.19 6.91h-.004l-3.392-.067H2.816a.2.2 0 00-.198.2v1.065a.6.6 0 01-.032.194L2 10.02v1.997a.2.2 0 00.151.194l2.391.313A3.397 3.397 0 017.87 9.8a3.397 3.397 0 013.342 2.8h11.197a3.397 3.397 0 013.341-2.8 3.397 3.397 0 013.342 2.8h1.96a.603.603 0 00.43-.181c.618-.63.693-1.616.177-2.333l-.91-1.265a.997.997 0 00-.562-.383l-4.522-1.054-.01-.002a3.61 3.61 0 01-.264-.078l-.1-.031a.605.605 0 00-.18-.031h-.012l-9.068-.179zm-1.113 1.832a.6.6 0 01.6-.6h2.049a.6.6 0 110 1.2h-2.049a.6.6 0 01-.6-.6zM7.87 11c-1.21 0-2.194.984-2.194 2.2 0 1.216.984 2.2 2.194 2.2 1.211 0 2.195-.984 2.195-2.2 0-1.216-.984-2.2-2.195-2.2zm17.88 0c-1.21 0-2.194.984-2.194 2.2 0 1.216.984 2.2 2.195 2.2 1.21 0 2.194-.984 2.194-2.2 0-1.216-.984-2.2-2.194-2.2z",
    fill: props.color
  }));
};
SvgSedan.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgSedan.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgSedan;